// 렌더 공용 수학 도우미. 프레임 루프에서 호출되므로 객체를 만들지 않는다.
export const TAU = Math.PI * 2;
export const clamp01 = (v: number): number => (v < 0 ? 0 : v > 1 ? 1 : v);
export const lerp = (a: number, b: number, t: number): number => a + (b - a) * t;
export const easeOut = (t: number): number => 1 - (1 - t) * (1 - t);
export const easeIn = (t: number): number => t * t;
export const easeInOut = (t: number): number => (t < 0.5 ? 2 * t * t : 1 - 2 * (1 - t) * (1 - t));

/** from → to 최단 각 차이(rad) */
export function angleDelta(from: number, to: number): number {
  let d = (to - from) % TAU;
  if (d > Math.PI) d -= TAU;
  else if (d < -Math.PI) d += TAU;
  return d;
}

/** 지수 감쇠 보간 계수: 프레임 시간에 독립적이다. */
export const damp = (sharpness: number, dt: number): number => 1 - Math.exp(-sharpness * dt);

/**
 * 개체별 틱 카운터(actTick, stateTick, phaseTick 등)의 보간 위상(COMBAT-FEEL 2.1).
 * phase = tick - rate * (1 - alpha). rate는 직전 step에서 실제 진행한 비율(heroRate/worldRate).
 */
export const phaseOf = (tickValue: number, rate: number, alpha: number): number => {
  const p = tickValue - rate * (1 - alpha);
  return p < 0 ? 0 : p;
};

/** 변환 행렬 하나를 열 우선으로 쓴다. R = Ry(yaw) * Rx(pitch), 크기 (sx, sy, sz). */
export function compose(a: Float32Array, o: number, px: number, py: number, pz: number, yaw: number, pitch: number, sx: number, sy: number, sz: number): void {
  const cy = Math.cos(yaw), sY = Math.sin(yaw), cp = Math.cos(pitch), sp = Math.sin(pitch);
  a[o] = cy * sx; a[o + 1] = 0; a[o + 2] = -sY * sx; a[o + 3] = 0;
  a[o + 4] = sY * sp * sy; a[o + 5] = cp * sy; a[o + 6] = cy * sp * sy; a[o + 7] = 0;
  a[o + 8] = sY * cp * sz; a[o + 9] = -sp * sz; a[o + 10] = cy * cp * sz; a[o + 11] = 0;
  a[o + 12] = px; a[o + 13] = py; a[o + 14] = pz; a[o + 15] = 1;
}
